import { render, staticRenderFns } from "./subproperty-settings-page.vue?vue&type=template&id=68627bd6&scoped=true&"
import script from "./subproperty-settings-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-settings-page.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-settings-page.vue?vue&type=style&index=0&id=68627bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68627bd6",
  null
  
)

export default component.exports